import { render, staticRenderFns } from "./RetornoOctadesk.vue?vue&type=template&id=bd344744"
import script from "./RetornoOctadesk.vue?vue&type=script&lang=ts"
export * from "./RetornoOctadesk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports